import { useEffect } from 'react'

export const useStoreMetrics = (pathname?: string) => {
  useEffect(() => {
    const loadAndRunMetrics = async () => {
      try {
        const { storeMetrics } = await import('@livechat/store-metrics')
        setTimeout(() => storeMetrics(), 0)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to load storeMetrics', error)
      }
    }

    loadAndRunMetrics()
  }, [pathname])
}

export default useStoreMetrics
